import { Atc, AtcPage } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithSearchableGetPage } from "./mixins/WithSearchableGetPage";

export class Endpoint extends BaseEndpoint("atcs") {}

export const AtcEndpoint = WithSearchableGetPage<typeof Endpoint, Atc, AtcPage>(Endpoint);
